export const RECEIVED_ALL_WORKFLOWS        = 'workflow/RECEIVED_ALL_WORKFLOWS';
export const RECEIVED_ERROR                = 'workflow/RECEIVED_ERROR';
export const RECEIVED_WORKFLOW_LOGS        = 'workflow/RECEIVED_WORKFLOW_LOGS';
export const RECEIVED_WORKFLOW_LOG_DETAIL  = 'workflow/RECEIVED_WORKFLOW_LOG_DETAIL';

